import { Redirect } from 'expo-router';
import { ROUTES } from '../../src/navigation/routes';

export default function RegisterRoute() {
  return <Redirect href={ROUTES.PUBLIC_SIGNUP} />;
}
